import React, { useState } from 'react';
import { Button, Modal, Box, Typography, TextField } from '@mui/material';
import * as XLSX from 'xlsx'; // Import xlsx library
import { buttonSX } from './GridFooter';

const DriverRouteUpload = ({ open, handleClose, handleRouteMatch }) => {
    const [file, setFile] = useState(null);

    const [validFile, setValidFile] = useState(false);

    const handleModalClose = () => {
      setValidFile(false);
      setFile(null);          // optional but recommended
      handleClose();
    };
  
    // Function to handle file change
    const handleFileChange = (event) => {
      const selectedFile = event.target.files[0];
      // Validate file type - only allow .xlsx files
      if (selectedFile && selectedFile.name.endsWith('.xlsx')) {
        setFile(selectedFile);
        setValidFile(true);
      } else {
        setFile(null); // Clear file selection
        setValidFile(false);
      }
    };
  
    // Function to handle file upload and parse the file
    const handleUpload = async () => {
      if (!file) {
        setValidFile(false);
        return;
      }
  
      try {
        // Read the file as an array buffer
        const reader = new FileReader();
  
        reader.onload = (e) => {
          // Check if e.target is null or undefined
          if (!e.target || !e.target.result) {
            setValidFile(false);
            return;
          }
  
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: 'array' });
  
          // Assume the first sheet is the one we want to parse
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
  
          // Parse the sheet into JSON with headers
          const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
  
          if (jsonData.length > 0) {
            // Use the first row as headers and the rest as values
            const headers = jsonData[0];
            const rows = jsonData.slice(1); // Remaining rows
  
            const formattedData = rows.map((row) => {
              const rowObj = {};
              headers.forEach((header, index) => {
                rowObj[header] = row[index] || ''; // Map each cell to its corresponding header
              });
              return rowObj;
            });

            console.log('Formatted JSON data:', formattedData);
  
            // Call the parent component's callback with the formatted data
            handleRouteMatch(formattedData);
  
            handleModalClose(); // Close the modal after processing
          }
        };
  
        reader.readAsArrayBuffer(file);
      } catch (error) {
        console.error('Error parsing file:', error);
      }
    };
  
    return (
      <Modal open={open} onClose={handleModalClose}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'white',
            padding: 4,
            width: 400,
            borderRadius: 2,
            boxShadow: 24,
          }}
        >
          <Typography variant="h6" gutterBottom>
            Upload file for fill
          </Typography>
  
          <TextField
            type="file"
            variant="outlined"
            fullWidth
            onChange={handleFileChange}
            sx={{ mb: 2 }}
          />
  
          <Box display="flex" justifyContent="flex-end" gap={2}>
            <Button onClick={handleModalClose} variant="outlined" sx={{...buttonSX}}>
              Cancel
            </Button>
            {validFile ?
            <Button
              onClick={handleUpload}
              variant="contained"
              color="success"
              sx={{border: 1,borderColor: theme => theme.palette.success.main, '&:hover': {border: 2, borderColor: theme => theme.palette.success.main},}}
              
            >
              Upload and Parse
            </Button> 
            : 
            <Button
              onClick={handleUpload}
              variant="outlined"
              color="error"
              disabled={true}
              sx={{
                '&.Mui-disabled': {
                borderColor: theme => theme.palette.error.main,
                color: theme => theme.palette.error.main,
                opacity: 0.6,
                },
              }}
            >
              File must be .xlsx
            </Button>}

          </Box>
        </Box>
      </Modal>
    );
  };
  
  export default DriverRouteUpload;
  
